<template>
    <div class="select-dropdown" :class="containerClass">
        <div class="container" :class="containerClass">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import classNames from 'classnames';
export default {
    name: 'im-select-dropdown',
    inject: {
        theme: 'theme'
    },
    computed: {
        containerClass() {
            return classNames(this.theme);
        }
    }
};
</script>

<style lang="scss" scoped>
.select-dropdown {
    min-width: 300px;
    padding-top: 2px;
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    z-index: var(--level-high);
    background: #fff;
    max-height: 300px;
    overflow: auto;
    &::-webkit-scrollbar {
        width: 0 !important;
    }
    .container {
        width: 100%;
        border-radius: 2px;
        padding: 0 10px;
    }
    &.standard {
        border: solid 1px #ebecf1;
    }
    &.template4 {
        border: solid 1px #d6dae8;
    }
    &.template1 {
        border: solid 1px #d5d5d5;
    }
}
</style>
